import data from './profile-games.json';
import type { FamousGame } from './types';

export type ProfileGame = FamousGame & {
  site: string;
  roundLabel: string;
  source: string;
  sourceLabel: string;
  checked: string;
  scoreNote?: string;
  additionalSource?: string;
  moments: { ply: number; san: string; title: string; body: string }[];
};
export const PROFILE_GAMES: ProfileGame[] = data.map(game => {
  const result = game.result;
  if (result !== '1-0' && result !== '0-1' && result !== '1/2-1/2') throw new Error(`Invalid result: ${game.slug}`);
  return { ...game, result, notes: Object.fromEntries(game.moments.map(moment => [moment.ply, `${moment.title}. ${moment.body}`])) };
});
export const gamesForPlayer = (name: string) => {
  const won = (game: ProfileGame) => (game.white === name && game.result === '1-0') || (game.black === name && game.result === '0-1');
  return PROFILE_GAMES.filter(game => game.white === name || game.black === name).sort((a, b) => Number(won(b)) - Number(won(a)) || b.year - a.year);
};

export function gameDownload(game: ProfileGame) {
  const headers = { Event: game.event, Site: game.site, Date: `${game.year}.??.??`, White: game.white, Black: game.black, Result: game.result, Source: game.source };
  return Object.entries(headers).map(([key, value]) => `[${key} "${value.replaceAll('"', '\\"')}"]`).join('\n') + '\n\n' + game.pgn + '\n';
}
